import React from 'react';
import { Box, FormControl, FormLabel, SimpleGrid, Textarea } from '@chakra-ui/react';
import CustomPaginationTable from 'components/Table/CustomPaginationTable';
import ConfirmationModal from 'components/confirmationModal/confirmationModal';
import Card from 'components/Cards/Card';
import FilterSearchBar from './components/FilterSearchBar';

// import DownloadCsv from 'components/Button/DownloadCsv';
import { getConsumerTableHeader } from 'components/Table/Headers/Users/userHeader';
import { useHistory } from 'react-router-dom';
import { useSuspendToggleUserMutation , useLazyGetConsumersQuery } from 'reducers/consumer.service';
import { MdOutlineEdit } from 'react-icons/md';

// user page
export default function UserPage() {
    const [isOpen , setisOpen] = React.useState(false);
    const [curUser, setcurUser] = React.useState(null);
    const [recentquery , setreceptquery] = React.useState({});

    const history = useHistory();
    //   const { refetch, isLoading, isError } = useGetConsumersQuery({});
    const [suspendUser] = useSuspendToggleUserMutation();

    const [getConsumers, { data, isLoading, isError , refetch }] = useLazyGetConsumersQuery();

    const onViewUser = (cell) => {
        history.push('/organization/user/consumer/' + cell._id);
    };
    const handleEdit = (data)=>{
        history.push('/organization/user/consumer/' + data._id + '?isEdit=true');
    };
    const onClickSuspend = (data)=>{
        setcurUser(data);
        setisOpen(true);
    };

    const items = [
        {
            label: 'Edit User',
            color: null,
            disabled: false,
            icon: <MdOutlineEdit/>,
            handleClick: handleEdit
        }

        // {
        //     label: 'Delete User',
        //     color: 'red.500',
        //     disabled: true,
        //     icon: <MdOutlineDelete/>,
        //     handleClick: onViewUser
        // }
    ];

    const handldSuspend = (values)=>{
        let action = curUser.isSuspendedByAdmin ? 'UNSUSPEND' : 'SUSPEND';
        setisOpen(false);

        suspendUser({ id: curUser?._id , body: { action , ...values }, recentquery }).unwrap().then((response)=>{
            //   setsuspendState({ ...suspendState , [curUser._id]: action });
            setcurUser(null);
        });
    };

    const userTableHeader = getConsumerTableHeader({
        permitOnlyOneActionIndex: 1,
        items,
        onViewUser,
        onClickSuspend
        //      suspendState
    });
    const handlePageChange = (query)=>{
        setreceptquery(query);
        return getConsumers(query).unwrap();
    };
    const handleModel = ()=>{
        setisOpen(!isOpen);
        setcurUser(null);
    };

    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <ConfirmationModal
                isOpen={isOpen}
                setisOpen={setisOpen}
                onClose={handleModel}
                successText={curUser?.isSuspendedByAdmin ? 'Un Suspend' : 'Suspend'}
                title={curUser?.isSuspendedByAdmin ? 'Unsuspend User' : 'Suspend User'}
                onActionConfirm={handldSuspend}
                modalBody={`Are you sure you want to ${curUser?.isSuspendedByAdmin ? 'unsuspend' : 'suspend'} user?`}
            >
                <FormControl>
                    <br />
                    <FormLabel htmlFor='message'>
                        Message
                    </FormLabel>
                    <Textarea name='message' variant="outline" placeholder="Write message here..." />
                </FormControl>

            </ConfirmationModal>

            <SimpleGrid
                mb="20px"
                columns={{ sm: 1, md: 1 }}
                spacing={{ base: '20px', xl: '20px' }}
            >
                <Card>
                    <FilterSearchBar
                        onRefresh={refetch}
                    />

                    <div className="page-main-box">
                        <CustomPaginationTable
                            {...data}
                            handlePageChange={handlePageChange}
                            handleRefresh={refetch}
                            columns={userTableHeader}
                            isLoading={isLoading}
                            isError={isError}
                        />
                    </div>
                </Card>
            </SimpleGrid>
        </Box>
    );
}
